import { Box, Typography, Paper } from '@mui/material';
import { FileOutputLog } from '../../services/fileOutputLogService';
import dayjs from 'dayjs';
import { colors } from '../../styles/colors';

interface FileOutputLogDetailProps {
  log: FileOutputLog;
}

export const FileOutputLogDetail = ({ log }: FileOutputLogDetailProps) => {
  return (
    <Paper sx={{ p: 3, maxWidth: '800px', width: '100%', maxHeight: '80vh', overflow: 'auto' }}>
      <Box display="flex" flexDirection="column" gap={2}>
        <Box>
          <Typography variant="subtitle2" color="text.secondary">
            File ID
          </Typography>
          <Typography>{log.uaid}</Typography>
        </Box>
        
        <Box>
          <Typography variant="subtitle2" color="text.secondary">
            PBM Name
          </Typography>
          <Typography>{log.pbmConnection?.pbm?.pbmName}</Typography>
        </Box>
        
        <Box>
          <Typography variant="subtitle2" color="text.secondary">
            Status
          </Typography>
          <Typography sx={{ 
            color: log.status.toLowerCase() === 'delivered' 
              ? colors.success 
              : log.status.toLowerCase() === 'error' 
                ? colors.error 
                : colors.pending 
          }}>
            {log.status}
          </Typography>
        </Box>
        
        <Box>
          <Typography variant="subtitle2" color="text.secondary">
            Created Date
          </Typography>
          <Typography>
            {dayjs(log.dateCreatedBySystem).format('MMM DD, YYYY h:mm a')}
          </Typography>
        </Box>

        {log.dateDeliveredToPBM && (
          <Box>
            <Typography variant="subtitle2" color="text.secondary">
              Delivered Date
            </Typography>
            <Typography>
              {dayjs(log.dateDeliveredToPBM).format('MMM DD, YYYY h:mm a')}
            </Typography>
          </Box>
        )}
        
        <Box>
          <Typography variant="subtitle2" color="text.secondary">
            Description
          </Typography>
          <Typography style={{ whiteSpace: 'pre-wrap' }}>{log.description}</Typography>
        </Box>
      </Box>
    </Paper>
  );
};

export default FileOutputLogDetail;
